import CardActions from '@mui/material/CardActions';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Grid from '@mui/material/Grid';
import { GetGroup } from '../../api/groups-endpoint';
import SnackbarAlert from '../../components/Alerts';
import DeleteGroupButton from '../../components/groups/DeleteGroupButton';
import AcceptButton from '../../components/AcceptButton';
import GroupDetails from '../../components/groups/GroupDetails';
import useConfigStyles from '../../components/useConfigStyles';
import { getLinkToEditGroup } from '../../navigator/links';
import { useCallback, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Group } from '../../types/group';
import { defaultGroup } from '../../types/defaultValues';
import useOperationAuthorizationChecks from '../../hooks/useOperationAuthorizationChecks';
import { UserOperations } from '../../types/user';

function GroupDetailsPage(): JSX.Element {
  const { groupName } = useParams<{ groupName: string }>();
  const [group, setGroup] = useState<Group>(defaultGroup);
  const [fetched, setFetched] = useState(false);
  const [responseMessage, setResponseMessage] = useState('');
  const [notify, toggleNotification] = useState(false);
  const classes = useConfigStyles();
  const navigate = useNavigate();
  const canEditGroup = useOperationAuthorizationChecks([UserOperations.GROUP_EDIT]);

  const fetchGroup = useCallback(async () => {
    if (groupName) {
      const response = await GetGroup(groupName);
      if (response.success && response.data) {
        setGroup(response.data);
      } else {
        setResponseMessage(response.message || '');
      }
      setFetched(response.success);
    }
  }, [groupName]);

  useEffect(() => {
    fetchGroup();
  }, [fetchGroup]);

  const DeleteButton = () => (
    <DeleteGroupButton
      group={group}
      className={classes.button}
      onDeleteFail={(message) => {
        setResponseMessage(message);
        toggleNotification(true);
      }}
    />
  );

  const handleCloseSnackbar = () => {
    toggleNotification(false);
  };

  const handleEditClick = () => {
    navigate(getLinkToEditGroup(groupName!));
  };

  return !fetched ? (
    <span>{responseMessage}</span>
  ) : (
    <>
      <Card>
        <CardContent>
          <GroupDetails group={group} editable={false} />
        </CardContent>
        <CardActions style={{'marginBottom': '24px'}}>
          <Grid container alignItems='center' justifyContent='center' direction='row' spacing={5}>
            <Grid item>
              {canEditGroup && <AcceptButton label='Edit Group' className={classes.button} onClick={handleEditClick} />}
            </Grid>
            <Grid item>
              <DeleteButton />
            </Grid>
          </Grid>
        </CardActions>
      </Card>
      <SnackbarAlert open={notify} message={responseMessage} handleClose={handleCloseSnackbar} />
    </>
  );
}

export default GroupDetailsPage;
